export default __webpack_public_path__ + "abbea5a38ce9a50c500df11b3b27b680.png";